import DoodleAccessoryCasque from './casque';
import DoodleAccessoryCoeur from './coeur';
import DoodleAccessoryDodo from './dodo';
import DoodleAccessoryEyepacth from './eyepacth';
import DoodleAccessoryHat from './Hat';
import DoodleAccessoryLunettes from './lunettes';
import DoodleAccessoryMoustache from './moustache';
import DoodleAccessoryParapluie from './parapluie';
import DoodleAccessoryPoliceHat from './police-hat';
import DoodleAccessoryStars from './stars';
import DoodleAccessorySunglasses from './sunglasses';
import DoodleAccessoryToque from './toque';

export {
	DoodleAccessoryCasque,
	DoodleAccessoryCoeur,
	DoodleAccessoryDodo,
	DoodleAccessoryEyepacth,
	DoodleAccessoryHat,
	DoodleAccessoryLunettes,
	DoodleAccessoryMoustache,
	DoodleAccessoryParapluie,
	DoodleAccessoryPoliceHat,
	DoodleAccessoryStars,
	DoodleAccessorySunglasses,
	DoodleAccessoryToque
};

// keys are saved in doodle configurations: never rename or remove one
export const DoodleAccessoryParts = {
	'casque': DoodleAccessoryCasque,
	'coeur': DoodleAccessoryCoeur,
	'dodo': DoodleAccessoryDodo,
	'eyepatch': DoodleAccessoryEyepacth,
	'hat': DoodleAccessoryHat,
	'lunettes': DoodleAccessoryLunettes,
	'moustache': DoodleAccessoryMoustache,
	'parapluie': DoodleAccessoryParapluie,
	'police-hat': DoodleAccessoryPoliceHat,
	'stars': DoodleAccessoryStars,
	'sunglasses': DoodleAccessorySunglasses,
	'toque': DoodleAccessoryToque
};

export type DoodleAccessoryKey = keyof typeof DoodleAccessoryParts;
